


















































import {
  HasTaskMixin, ShowFinally, Message, HumanizeTime,
} from 'mycorems-app-shared';
import { Template, TemplateFilters, QPagination } from '../types';
import repository from './template-repository';
import SaveTemplateBtn from './SaveTemplateBtn.vue';
import DeleteTemplateBtn from './DeleteTemplateBtn.vue';
import RouterLink from '../routing/RouterLink.vue';

interface Data {
  templates: Template[],
  pagination: QPagination,
}

export default HasTaskMixin.extend({
  components: {
    SaveTemplateBtn,
    DeleteTemplateBtn,
    RouterLink,
    HumanizeTime,
    ShowFinally,
    Message,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      templates: [],
      pagination: {
        rowsPerPage: 5,
        page: 1,
        rowsNumber: 0,
      },
    };
  },
  computed: {
    columns(): object[] {
      return [
        {
          name: 'name',
          label: 'Name',
          align: 'left',
        },
        {
          name: 'createdAt',
          label: 'Created',
          align: 'left',
        },
        {
          name: 'actions',
          align: 'right',
        },
      ];
    },
    offset(): number {
      return ((this.pagination.page - 1) * this.pagination.rowsPerPage);
    },
    filters(): TemplateFilters {
      return {
        accountId: this.accountId,
      };
    },
  },
  watch: {
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    add(template: Template): void {
      this.templates.unshift(template);
    },
    update(template: Template): void {
      const index = this.findIndex(template);
      if (index >= 0) {
        this.templates.splice(index, 1, template);
      }
    },
    remove(template: Template): void {
      const index = this.findIndex(template);
      if (index >= 0) {
        this.templates.splice(index, 1);
        this.pagination.rowsNumber -= 1;
      }
    },
    findIndex(template: Template): number {
      return this.templates.findIndex((t: Template) => t.id === template.id);
    },
    load(): void {
      this.task = repository.findAll(this.filters);
      this.task.then((templates: Template[]) => {
        this.templates = templates;
        this.pagination.rowsNumber = templates.length;
      });
    },
  },
});
